import ACREAPI from 'utils/services/ACREAPI';

const ENDPOINT_URL_PREFIX = 'roles/';

export default class Roles {
    static index = () => {
        return ACREAPI.authInstance().get(ENDPOINT_URL_PREFIX);
    };
}
